import React from 'react';
import { ArrowLeft, ShieldCheck, CheckCircle, Navigation, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import NearbyAreas from './NearbyAreas';
import AreaDedicatedArticle from '../AreaDedicatedArticle';
import AreaRelatedArticles from '../AreaRelatedArticles';

const NewCityTemplate = ({ areaData, displayName, phone, brand, images }) => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
      {/* Header Section */}
      <header id="header" className="area-hero-header" style={{
        background: 'linear-gradient(135deg, #1b5e20 0%, #4caf50 100%)',
        color: 'white',
        borderRadius: '1.5rem',
        padding: '3rem 2rem',
        marginBottom: '2rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        marginTop: '2rem'
      }}>
        <nav aria-label="الرجوع إلى قائمة المناطق">
          <Link to="/areas" style={{
            position: 'absolute', top: '1rem', left: '1rem', color: 'white',
            textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem',
            fontSize: '1rem', fontWeight: 600
          }}>
            <ArrowLeft size={20} /> المناطق
          </Link>
        </nav>
        <nav aria-label="مسار التنقل" style={{ fontSize: '0.95rem', marginBottom: '1rem', opacity: 0.95, direction: 'rtl', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>الرئيسية</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <Link to="/areas" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>مناطق الخدمة</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <span style={{ color: '#ffffff', fontWeight: 800 }}>ونش انقاذ {displayName}</span>
        </nav>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: '1rem', direction: 'rtl' }}>
          ونش انقاذ {displayName} | خصم 50%
        </h1>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.8rem',
          flexWrap: 'wrap', marginBottom: '1rem', direction: 'rtl'
        }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            background: 'rgba(255,255,255,0.2)', padding: '0.5rem 1.2rem',
            borderRadius: '2rem', fontSize: '1.05rem', fontWeight: 700
          }}>
            <Clock size={18} color="#ffc107" />
            <span>وقت الاستجابة: {areaData.responseTime}</span>
          </div>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            background: 'rgba(255,255,255,0.2)', padding: '0.5rem 1.2rem',
            borderRadius: '2rem', fontSize: '1.05rem', fontWeight: 700
          }}>
            <CheckCircle size={18} color="#c8e6c9" />
            <span>خدمة إنقاذ للكمبوندات السكنية والمدن الجديدة</span>
          </div>
        </div>
        <p style={{ fontSize: '1.2rem', opacity: 0.95, maxWidth: '750px', margin: '0 auto 1rem auto', direction: 'rtl', lineHeight: 1.8 }}>
          {areaData.intro}
        </p>
      </header>

      {/* Security Protocol for Compounds */}
      <aside aria-label="إجراءات الدخول للكمبوندات" style={{ background: '#e8f5e9', border: '1px solid #4caf50', padding: '2rem', borderRadius: '1.5rem', marginBottom: '2rem', direction: 'rtl' }}>
        <h3 style={{ color: '#1b5e20', fontSize: '1.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <ShieldCheck size={24} /> إجراءات الدخول للكمبوندات
        </h3>
        <p style={{ fontSize: '1.1rem', lineHeight: 1.8, color: '#2e7d32' }}>
          نحن نتفهم تماماً بروتوكولات الأمن المتبعة داخل البوابات السكنية في {displayName}. جميع سائقينا يحملون هويات معتمدة وأوناشنا مرخصة لتسهيل وسرعة الدخول عبر بوابات الأمن بمجرد تنسيقك معهم لدخول الونش للإنقاذ الفوري.
        </p>
      </aside>

      {/* Pricing Table */}
      <section id="pricing" aria-labelledby="pricing-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '2px solid #e8f5e9', direction: 'rtl' }}>
        <h2 id="pricing-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1b5e20', marginBottom: '1.5rem', textAlign: 'center' }}>
          جدول أسعار الإنقاذ التقريبية في {displayName}
        </h2>
        <table aria-labelledby="pricing-heading" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'right' }}>
          <thead>
            <tr style={{ background: '#2e7d32', color: 'white' }}>
              <th scope="col" style={{ padding: '1rem', border: '1px solid #ddd' }}>نوع الخدمة</th>
              <th scope="col" style={{ padding: '1rem', border: '1px solid #ddd' }}>السعر التقديري</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>سحب سيارة ملاكي داخل {displayName}</td>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>يبدأ من 250 ج.م</td>
            </tr>
            <tr>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>إنقاذ من الطرق السريعة والمحاور المحيطة</td>
              <td style={{ padding: '1rem', border: '1px solid #ddd' }}>يبدأ من 350 ج.م</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Dispatch Points Section */}
      {areaData.dispatchPoints && areaData.dispatchPoints.length > 0 && (
        <section id="dispatch-points" aria-labelledby="dispatch-heading" style={{
          background: 'white', borderRadius: '1.5rem', padding: '2rem',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem',
          border: '2px solid #e8f5e9', direction: 'rtl'
        }}>
          <h2 id="dispatch-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1b5e20', marginBottom: '1.5rem', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
            <Navigation size={24} color="#2e7d32" /> نقاط وتمركزات أوناشنا الميدانية في {displayName}
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1rem' }}>
            {areaData.dispatchPoints.map((dp, i) => (
              <div key={i} style={{ background: '#f1f8e9', border: '1px solid #c8e6c9', borderRadius: '1rem', padding: '1rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#2e7d32', flexShrink: 0 }}></div>
                <span style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1b5e20' }}>{dp}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Coverage Areas */}
      <section id="local-coverage" aria-labelledby="coverage-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '1px solid #ddd', direction: 'rtl' }}>
        <h2 id="coverage-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1b5e20', marginBottom: '1.5rem', textAlign: 'center' }}>
          المعالم والمناطق المغطاة في {displayName}
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
          <article style={{ background: '#f8f9fa', padding: '1.2rem', borderRadius: '1rem', border: '1px solid #e9ecef' }}>
            <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#4caf50', marginBottom: '0.8rem' }}>التجمعات والمولات:</h3>
            <ul style={{ paddingRight: '1.2rem', margin: 0, lineHeight: 1.8 }}>
              {areaData.landmarks.map((lm, i) => <li key={i}>{lm}</li>)}
            </ul>
          </article>
          <article style={{ background: '#f8f9fa', padding: '1.2rem', borderRadius: '1rem', border: '1px solid #e9ecef' }}>
            <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#4caf50', marginBottom: '0.8rem' }}>الشوارع والطرق السريعة الرابطة:</h3>
            <ul style={{ paddingRight: '1.2rem', margin: 0, lineHeight: 1.8 }}>
              {areaData.streets.map((st, i) => <li key={i}>{st}</li>)}
            </ul>
          </article>
        </div>

        {/* Local Notes */}
        {areaData.localNotes && areaData.localNotes.length > 0 && (
          <aside aria-label={`إرشادات وملاحظات الإنقاذ في ${displayName}`} style={{
            background: '#e8f5e9', padding: '1.2rem', borderRadius: '1rem',
            border: '1px solid #4caf50', marginTop: '1.5rem', direction: 'rtl'
          }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#1b5e20', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              <ShieldCheck size={20} color="#2e7d32" />
              إرشادات وملاحظات الإنقاذ في {displayName}:
            </h3>
            {areaData.localNotes.map((note, i) => (
              <p key={i} style={{ margin: '0.4rem 0', fontSize: '1.05rem', color: '#1b5e20', lineHeight: 1.7 }}>• {note}</p>
            ))}
          </aside>
        )}
      </section>

      {/* Dedicated Supporting Article Section */}
      <AreaDedicatedArticle
        areaData={areaData}
        displayName={displayName}
        templateType="NewCity"
        phone={phone}
      />

      {/* Related Supporting Articles & Pillar Guides */}
      <AreaRelatedArticles areaName={displayName} />

      {/* FAQ */}
      {areaData.faqs && areaData.faqs.length > 0 && (
        <section id="faq" aria-labelledby="faq-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '1px solid #ddd', direction: 'rtl' }}>
          <h2 id="faq-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1b5e20', marginBottom: '1.5rem', textAlign: 'center' }}>الأسئلة الشائعة للإنقاذ في {displayName}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {areaData.faqs.map((faq, index) => (
              <article key={index} style={{ background: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '1rem', padding: '1.5rem' }}>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#4caf50', marginBottom: '0.5rem' }}>{faq.q}</h3>
                <p style={{ margin: 0, color: '#333', lineHeight: 1.6 }}>{faq.a}</p>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* Nearby Areas — Internal Linking */}
      <NearbyAreas nearby={areaData.nearby} accentColor="#1b5e20" />
    </div>
  );
};
export default NewCityTemplate;
